import request from '@/utils/request'

// 查询直播礼物列表
export function listCommunityLiveGift(query) {
  return request({
    url: '/community/admin/community/live/gift/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询直播礼物分页
export function pageCommunityLiveGift(query) {
  return request({
    url: '/community/admin/community/live/gift/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询直播礼物详细
export function getCommunityLiveGift(data) {
  return request({
    url: '/community/admin/community/live/gift/detail',
    method: 'get',
    params: data
  })
}

// 新增直播礼物
export function addCommunityLiveGift(data) {
  return request({
    url: '/community/admin/community/live/gift/add',
    method: 'post',
    data: data
  })
}

// 修改直播礼物
export function updateCommunityLiveGift(data) {
  return request({
    url: '/community/admin/community/live/gift/edit',
    method: 'post',
    data: data
  })
}

// 删除直播礼物
export function delCommunityLiveGift(data) {
  return request({
    url: '/community/admin/community/live/gift/delete',
    method: 'post',
    data: data
  })
}
